import { createAction, props } from "@ngrx/store";

export const setStartTime = createAction('[Timer] Set Start Time');
export const updateTimer = createAction('[Timer] Update Timer');
export const updateTimerSuccess = createAction('[Timer] Update Timer Success', (expired: boolean) => ({ expired }));
export const updateTimerFailure = createAction('[Timer] Update Timer Failure', props<{ error: string }>());

export const timerActions = {    
    setStartTime,
    updateTimer,
    updateTimerSuccess,
    updateTimerFailure
}